import { parsePct, pctStr } from "./sgkConst";

const inp = "w-20 px-2 py-1 text-sm text-center border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";

// 4/1-a Toplam satırının altı: 5510 SK indirimi (işveren payından düşülür, şu an %2) + indirimli toplam satırı
export default function SgkDiscountRows({ value, total, editable, onChange, prefix }) {
  const disc = parsePct(value);
  const d = disc == null || Number.isNaN(disc) ? 0 : disc;
  return (
    <>
      <tr className="border-t border-slate-200 bg-amber-50/60" data-testid={`${prefix}-row-indirim_5510`}>
        <td className="px-3 py-1.5 text-sm text-amber-900 font-semibold">5510 SK İndirimi <span className="font-normal text-xs text-slate-600">(işveren payından düşülür)</span></td>
        <td className="px-3 py-1.5 text-sm text-center">
          {editable
            ? <input value={value ?? ""} onChange={(e) => onChange("indirim_5510", "employer", e.target.value)} data-testid={`${prefix}-employer-indirim_5510`} inputMode="decimal" className={inp} placeholder="örn. 2" />
            : <span data-testid={`${prefix}-employer-indirim_5510`}>{d ? `−${pctStr(d)}` : "-"}</span>}
        </td>
        <td className="px-3 py-1.5 text-sm text-center text-slate-400">-</td>
        <td className="px-3 py-1.5 text-sm text-center font-semibold text-amber-900" data-testid={`${prefix}-total-indirim_5510`}>{d ? `−${pctStr(d)}` : "-"}</td>
      </tr>
      <tr className="border-t border-slate-300 bg-emerald-100 font-bold" data-testid={`${prefix}-total-4a-net`}>
        <td className="px-3 py-1.5 text-sm uppercase">Genel Toplam <span className="font-normal normal-case text-xs text-slate-600">(5510 SK indirimi düşülmüş)</span></td>
        <td className="px-3 py-1.5 text-sm text-center" data-testid={`${prefix}-total-4a-net-employer`}>{pctStr(total.employer - d)}</td>
        <td className="px-3 py-1.5 text-sm text-center" data-testid={`${prefix}-total-4a-net-employee`}>{pctStr(total.employee)}</td>
        <td className="px-3 py-1.5 text-sm text-center" data-testid={`${prefix}-total-4a-net-total`}>{pctStr(total.total - d)}</td>
      </tr>
    </>
  );
}
